import { jsx as _jsx } from "react/jsx-runtime";
// Must run before any `import … from 'moment'` graph loads plugins onto dayjs.
import 'vendor/dayjs-moment-setup';
import { RouterProvider } from '@rocketlane/rocket-router';
import { InitWorkerApi } from 'initWorker';
import { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './tailwind.css';
import '@rocketlane/chatqa/styles';
import 'react-cmdk/dist/cmdk.css';
import { router } from 'routes/app-routes';
import { installDomReconciliationGuard } from 'utils/dom-reconciliation-guard';
import { isTauriApp } from 'utils/is-tauri';
import { installScrollbarVisibility } from 'utils/scrollbar-visibility';
import { scheduleMfSingletonChecks } from 'utils/mf-singleton-telemetry';
import { initDatadog, initDatadogRum } from 'vendor/datadog-rum';
// Must run before createRoot (and before any MF remote renders) so React's
// commit phase never throws on DOM mutated out-of-band (browser translation,
// extensions). See the module doc.
installDomReconciliationGuard();
installScrollbarVisibility();
initDatadog();
initDatadogRum();
// Alarm on the Module Federation dual-React state (2026-07 incident) directly,
// instead of relying on downstream removeChild crashes as the detector.
scheduleMfSingletonChecks();
// Skip initWorker prefetch in Tauri — the worker always hits accounts/get-meta,
// which is unsupported on api.rocketlane.com. Desktop uses get-mobile-meta via AccountAPI.
if (window.location.hostname === 'localhost' && !isTauriApp()) {
    InitWorkerApi.setData();
}
const container = document.getElementById('root');
export const root = createRoot(container);
root.render(// Disabling strict mode now. Because its breaking Antd components like Popover, Tooltip etc
// context: https://github.com/ant-design/ant-design/issues/26136, https://github.com/ant-design/ant-design/issues/34876
// <StrictMode>
/*#__PURE__*/ _jsx(Suspense, {
    fallback: null,
    name: "RootSuspense",
    children: /*#__PURE__*/ _jsx(RouterProvider, {
        router: router
    })
}));
